import { Component } from '@angular/core';
import { ArticleSeoComponent } from '../article-seo';
import { ArticleTemplateComponent } from '../article-template/article-template.component';

@Component({
  selector: 'app-article-09',
  imports: [ArticleTemplateComponent],
  templateUrl: './article-09.component.html',
  styleUrls: []
})
export class Article09Component extends ArticleSeoComponent {
  protected readonly seo = {
    pageTitle: 'Como evitar prejuízo em leilão imobiliário | Casato Brasil',
    description: 'Saiba como reduzir riscos em leilão imobiliário analisando edital, matrícula, custos extras, ocupação e liquidez antes do lance.'
  };
}
